import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IPagedItemsParams } from '~src/httpClient/serverApi/types/IPage';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';

// We don't actually support paging yet so the IGetItemsResult isnt really needed
export interface IGetConnectedApplicationsResult extends IGetItemsResult {
  connectedApplications: {
    connectedApplication: IConnectedApplicationType[];
  };
}

function getConnectedApplicationsRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'GET',
    endpoint: 'connected-applications',
    serverWideRequest: false
  };
}

export function callGetConnectedApplications(params: IPagedItemsParams) {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationsResult>({
    config: getConnectedApplicationsRequestConfig(),
    request: null,
  });
}

